import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=156adbdd&scoped=true&"
import script from "./StaticPage.vue?vue&type=script&lang=js&"
export * from "./StaticPage.vue?vue&type=script&lang=js&"
import style0 from "./StaticPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StaticPage.vue?vue&type=style&index=1&id=156adbdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156adbdd",
  null
  
)

export default component.exports